import {SET_SUBSCRIPTIONS, SET_SUBSCRIPTION_LOADING} from './actions';

export const categories = (state = {subscriptionsLoading:[],  subscriptions : []}, action) => {
  switch (action.type) {

    case SET_SUBSCRIPTIONS:
      return Object.assign({}, state, {
        subscriptions: action.subscriptions
      });

    case SET_SUBSCRIPTION_LOADING:
      if(action.loading===true)
      {
        return {
          ...state,
          subscriptionsLoading: [...state.subscriptionsLoading, action.categoryId]
        };
      }
      else
      {
        return {
          ...state,
          subscriptionsLoading: state.subscriptionsLoading.filter(category => category !== action.categoryId),
        };
      }

    default:
      return state;
  }

};